/*!
 *
 *  switch-fontsize.js
 *
 */


var $html = $('html');
var $btn = $('.st-Switch_Btn');

var setSize = function( size ){
	if( size === 'large' ){
		$html.addClass('sw-FontLarge');
	}else{
		$html.removeClass('sw-FontLarge');
	};
	$btn.toggleClass('st-Switch_Btn-current');
	$.removeCookie('jichi-font-size');
	$.cookie('jichi-font-size', size, { expires: 7, path: '/hospital/top/' });
};

module.exports = function(options){
	var cookie = $.cookie('jichi-font-size');
	var current;
	if( cookie ){
		current = cookie;
	}else{
		current = 'default';
		$.cookie('jichi-font-size', 'default', { expires: 7, path: '/hospital/top/' });
	};

	if( current !== 'default' ){
		setSize(current);
	};

	$btn.on('tap', function(e){
		e.preventDefault();
		if( !$(this).is('.st-Switch_Btn-current') ){
			setSize( $(this).val() );
		};
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/switch-fontsize.js
// module id = 19
// module chunks = 0